const allowedSymbols = /^[+]?[-0-9]+$/;

export default phone => !phone || allowedSymbols.test(phone);



// WEBPACK FOOTER //
// ./src/utils/validations/phoneValidator.js